import { combineReducers } from "redux";
import AuthReducer from "./auth/auth.reducers.js"
import otpVerificationReducer from "./verifyOTP/verifyOTP.reducers.js";
import sendOtpReducer from "./sendOTP/sendOTP.reducers.js";
import ProfileReducer  from "./profile/editProfile.reducer.js";
import ConfigdataReducer from "./configData/configData.reducers.js";
import PaymentReducer from "./payment/payment.reducers.js";
import RakutenReducer from "./rekuten/rakuten.reducer.js";

export default combineReducers({
  AuthReducer,
  otpVerificationReducer,
  sendOtpReducer,
  ProfileReducer,
  ConfigdataReducer,
  PaymentReducer,
  RakutenReducer
});
